import axios from "axios";
import * as helper from "../../helper";
import store from "../index";
// import * as socket from "../../socket";

const state = {
  organisation_id: 0,
  user_id: 0,
  forceLogin: 0,
  loading: false,
  syncLoading: false,
  user: {},
  session: {
    time: "",
    username: "",
    type: "",
    required: "",
    denomination: "",
    last_session_print_data: "",
    id: 0,
  },
};

const actions = {
  authMobile({ commit }, data) {
    return new Promise((resolve, reject) => {
      commit("loginRequest");
      axios
        .post(data.url, data)
        .then((res) => {
          if (res.data.status === "account_not_active") {
            commit(
              "notifications/errorMessage",
              {
                type: "authmobile",
                msg: res.data.message,
              },
              {
                root: true,
              }
            );
            reject(res);
          } else if (res.data.status === "otp_sent") {
            commit(
              "notifications/errorMessage",
              {
                type: "authmobile",
                msg: "User not exists !",
              },
              {
                root: true,
              }
            );
            reject(res);
          } else if (res.data.status === "m_not_found") {
            commit(
              "notifications/errorMessage",
              {
                type: "authmobile",
                msg: res.data.message,
              },
              {
                root: true,
              }
            );
            reject(res);
          } else if (res.data.status === "fail") {
            commit(
              "notifications/errorMessage",
              {
                type: "authmobile",
                msg: res.data.message,
              },
              {
                root: true,
              }
            );
            reject(res);
          } else if (res.data.status === "login_redirect") {
            commit("saveDetails", res.data.data);
          }
          resolve(res);
        })
        .catch((err) => {
          console.log("err.response.data.message");
          reject(err);
        });
    });
  },
  login({ commit, dispatch, rootState, rootGetters }, data) {
    return new Promise((resolve, reject) => {
      commit("loginRequest");
      axios
        .post(data.url, data)
        .then((res) => {
          if (res.data.status === "account_not_active") {
            commit(
              "notifications/errorMessage",
              {
                type: "login",
                msg: res.data.message,
              },
              {
                root: true,
              }
            );
            reject(res);
          } else if (res.data.status === "invalid_credentials") {
            commit(
              "notifications/errorMessage",
              {
                type: "login",
                msg: res.data.message,
              },
              {
                root: true,
              }
            );
            reject(res);
          } else if (res.data.status === "fail") {
            commit(
              "notifications/errorMessage",
              {
                type: "login",
                msg: res.data.message,
              },
              {
                root: true,
              }
            );
            reject(res);
          } else if (res.data.status === "warning") {
            commit(
              "notifications/errorMessage",
              {
                type: "login",
                msg: res.data.message,
              },
              {
                root: true,
              }
            );
            commit("forceLogin");
            reject(res);
          } else if (res.data.status === "login_redirect") {
            // const token = res.data.data.api_token;
            //  localStorage.setItem("token", token);
            // sessionStorage.setItem("token", token);
            // axios.defaults.headers.common['Authorization'] = token;
            // this.state.terminal_id = 1;
            commit("getUserData", res.data.data);
            commit("system/getSettings", res.data.settings, {
              root: true,
            });
            let country_details = {
              phone_digit: 10,
              dial_code: "+91",
              country_id: 101,
            };
            if (
              res.data.settings.vendor_login_details.hasOwnProperty(
                "country_details"
              )
            ) {
              country_details =
                res.data.settings.vendor_login_details.country_details;
            }
            commit("system/getCountryDetails", country_details, {
              root: true,
            });
            commit("billing/setDummyCustomer", res.data.settings, {
              root: true,
            });
            commit("system/setFeatures", res.data.settings, {
              root: true,
            });
            commit("setSessionDetails", res.data.settings);
            // dispatch("cartDetails");
            commit("billing/clearPayBalDeposit", null, {
              root: true,
            });
            helper.syncDataInbound();
            // socket.openConn();
            resolve(res);
            if (
              rootGetters["system/salesPersonActive"] &&
              !rootState.system.isOffline
            ) {
              dispatch("billing/getSalesPersonList", null, {
                root: true,
              });
            }
            if (!rootState.system.isOffline) {
              dispatch("extra/saveStates", null, {
                root: true,
              });
            }
            dispatch("offline/saveOfflineDummyCustomer", null, {
              root: true,
            });
          }
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  saveSession({ state, dispatch }, data) {
    return new Promise((resolve, reject) => {
      axios
        .post(data.url, data)
        .then((res) => {
          if (data.session_type == "open") {
            if (res.data.status == "success") {
              if (res.data.hasOwnProperty("data")) {
                state.session.time = res.data.data.opening_time;
                state.session.id = res.data.data.id;
              }
              state.session.type = "close";
              // console.log(this.state.settings['settlement']);
              dispatch("system/getLatestSettings", null, {
                root: true,
              });
              // alert(res.data.message);
            }
          } else if (data.session_type == "close") {
            state.session.id = 0;
            if (res.data.status == "success") {
              dispatch("system/getLatestSettings", null, {
                root: true,
              });
              // alert(res.data.message);
            }
          }
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  logout({ commit, rootState }) {
    return new Promise((resolve) => {
      let data = {
        api_token: store.state.sessions.user.api_token,
        terminal_id: store.state.system.settings.terminal_id,
        v_id: store.state.sessions.user.v_id,
        store_id: store.state.sessions.user.store_id,
        vu_id: store.state.sessions.user.vu_id,
        trans_from: rootState.system.trans_from,
        mobile: store.state.sessions.user.mobile,
        url: "/vendor/logout",
        // udidtoken: store.state.sessions.license
      };
      axios
        .get(data.url, {
          params: data,
        })
        .then((res) => {
          commit("destroyToken");
          // socket.closeConn();
          resolve(res);
        });
    });
  },
};

const mutations = {
  setSessionId(state, data) {
    state.session.id = data;
  },
  forceLogin(state) {
    state.forceLogin = 1;
  },
  loginRequest(state) {
    state.loading = true;
  },
  saveDetails(state, data) {
    state.loading = false;
    state.organisation_id = data.v_id;
    state.user_id = data.vu_id;
  },
  getUserData(state, data) {
    state.user = data;
  },
  setSessionDetails(state, sdata) {
    let settleData = {};
    Object.keys(sdata).map((item) => {
      if (item == "settlement") {
        let data = sdata[item];
        // Check denomination
        let denomination = "";
        let type = "";
        let isRequired = 0;
        if (data.denomination.status == 1) {
          denomination = data.denomination.currency;
        }

        // Check Close Session
        if (data.closing_previous_balance_status == 0) {
          if (data.closing_previous_session_compulsory.status == 1) {
            isRequired = 1;
            type = "close";
          } else {
            if (data.opening_balance_status == 0) {
              type = "open";
            } else {
              type = "close";
            }
          }
        } else if (data.closing_previous_balance_status == 1) {
          // Check Open Session
          if (data.opening_balance_status == 0) {
            if (data.open_sesssion_compulsory.status == 1) {
              isRequired = 1;
              type = "open";
            } else {
              type = "open";
            }
          } else if (data.opening_balance_status == 1) {
            type = "close";
          } else {
            type = "close";
          }
        }

        settleData = {
          type: type,
          denomination: denomination,
          required: isRequired,
        };

        state.session.type = type;
        state.session.denomination = denomination;
        state.session.required = isRequired;
        state.session.time = data.session_started_at;
      }
    });
    state.session.username = state.user.first_name + " " + state.user.last_name;
  },
  saveLastSessionPrintData(state, data) {
    state.session.last_session_print_data = data;
  },
  destroyToken(state) {
    state.user = {};
  },
  clearLoginData(state) {
    state.user_id = 0;
    state.organisation_id = 0;
  },
  updateProfile(state, data) {
    state.user.mobile = data.mobile;
    state.user.email = data.email;
    state.user.first_name = data.first_name;
    state.user.last_name = data.last_name;
    state.user.dob = data.dob;
    state.user.gender = data.gender;
  },
  disableLoading(state) {
    state.loading = false;
  },
};

const getters = {
  checkOrgData: (state) => {
    let check = false;
    if (state.organisation_id != 0 || state.user_id != 0) {
      check = true;
    }
    return check;
  },
  getCustomerParam(state, getters, rootState) {
    if (rootState.billing.billing.customer.data != "") {
      return {
        v_id: parseInt(state.organisation_id),
        store_id: parseInt(state.user.store_id),
        trans_from: rootState.system.trans_from,
        c_id: parseInt(rootState.billing.billing.customer.data.c_id),
        api_token: rootState.billing.billing.customer.data.api_token,
        vu_id: parseInt(state.user.id),
        customer_group_code:
          rootState.billing.billing.customer.customer_group_code,
      };
    } else {
      return {
        v_id: parseInt(state.organisation_id),
        store_id: parseInt(state.user.store_id),
        trans_from: rootState.system.trans_from,
        c_id: parseInt(rootState.billing.billing.dumuy_customer.c_id),
        api_token: rootState.billing.billing.dumuy_customer.api_token,
        vu_id: parseInt(state.user.id),
        customer_group_code:
          rootState.billing.billing.dumuy_customer.customer_group_code,
        terminal_id: rootState.system.settings.terminal_id,
      };
    }
  },
  getEssentialsData(state, getters, rootState) {
    return {
      terminal_id: rootState.system.settings.terminal_id,
      v_id: state.user.v_id,
      store_id: state.user.store_id,
      api_token: state.user.api_token,
      vu_id: state.user.id,
      trans_from: rootState.system.trans_from,
    };
  },
  getVendorDetails(state, getters, rootState) {
    return {
      v_id: parseInt(state.organisation_id),
      vu_id: parseInt(state.user.id),
      store_id: parseInt(state.user.store_id),
      api_token: state.user.api_token,
      terminal_id: rootState.system.settings.terminal_id,
    };
  },
  phonepeDetails(state, getters, rootState) {
    return {
      v_id: parseInt(state.organisation_id),
      vu_id: parseInt(state.user.id),
      storeId: parseInt(state.user.store_id),
      api_token: state.user.api_token,
      terminalId: rootState.system.settings.terminal_id,
    };
  },
};
export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
};
